<template>
  <div>
    <h2>
      Withdraw funds
    </h2>
    <div v-if="errors.length" class="alert alert-danger">
      <ul>
        <li v-for="error in errors" :key="error.msg">
          {{ error.msg }}
        </li>
      </ul>
    </div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group
        :label-cols="4"
        horizontal
        breakpoint="md"
        label="Enter Amount"
      >
        <b-form-input v-model.trim="withdrawal.amount" />
      </b-form-group>
      <b-form-group
        :label-cols="4"
        horizontal
        breakpoint="md"
        label="Enter Paypal Email"
      >
        <b-form-input v-model.trim="withdrawal.paypalEmail" />
      </b-form-group>
      <b-form-group
        :label-cols="4"
        horizontal
        breakpoint="md"
        label="Confirm Paypal Email"
      >
        <b-form-input v-model.trim="withdrawal.paypalEmailConfirm" />
      </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
    <b-modal id="modal1" ref="myModalRef2">
      <p class="my-4">Your payment request is being processed</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" @click="close">
          Close
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'Account',
  data() {
    return {
      data: {},
      errors: [],
      withdrawal: {}
    };
  },
  created() {},
  methods: {
    onSubmit() {
      this.errors = [];
      this.loading = true;

      API.post('withdrawal/request', this.withdrawal).then(res => {
        this.loading = false;
        if (res.status === 'ok') {
          this.$refs.myModalRef2.show();
        } else {
          this.errors = res.errors;
        }
      });
    },
    close() {
      this.$refs.myModalRef2.hide();
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped></style>
